import * as React from 'react';

type GetEventingTrackingData = { index: number };
export const GetModuleSectionEventTrackingDataContext = React.createContext<GetEventingTrackingData>({ index: 999 });
export const useModuleSectionEventTrackingData = () => React.useContext(GetModuleSectionEventTrackingDataContext);
